const RANGES = {
      year: 365 * 24 * 60 * 60,
     month:  30 * 24 * 60 * 60,
      week:   7 * 24 * 60 * 60,
       day:       24 * 60 * 60,
      hour:            60 * 60,
    minute:                 60,
    second:                  1,
};

const rtf = new Intl.RelativeTimeFormat(navigator.language, { numeric: 'auto' });
let observer = false;
const tracked = new Map; // null -> tracked but no timeout

export function formatTimeAgo(date) {
    const elapsed = (date - new Date) / 1000;
    const elapsedAbs = Math.abs(elapsed);
    for(const unit in RANGES) {
        const seconds = RANGES[unit];
        if(elapsedAbs >= seconds || unit === 'second')
            return { unit, text: rtf.format(Math.round(elapsed / seconds), unit) };
    }

    return { text: date.toLocaleString(), unit: 'none' };
}

export function getUpdateDelay(unit) {
    switch(unit) {
        case 'second': return                    1000;
        case 'minute': return               60 * 1000;
        case 'hour':   return          60 * 60 * 1000;
        case 'day':    return     24 * 60 * 60 * 1000;
        default:       return 7 * 24 * 60 * 60 * 1000;
    }
}

export function trackTimeElement(element) {
    if(element instanceof HTMLTimeElement && !tracked.has(element)) {
        const update = () => {
            if(!tracked.has(element))
                return; // no longer tracked

            const { text, unit } = formatTimeAgo(Date.parse(element.dateTime));
            element.textContent = text;
            tracked.set(element, setTimeout(update, getUpdateDelay(unit)));
        };

        tracked.set(element, null);
        update();
    }

    return element;
}

export function untrackTimeElement(element) {
    const timeout = tracked.get(element);
    if(timeout !== undefined)
        return;

    clearTimeout(timeout);
    tracked.delete(element);
}

export function trackTimeElements() {
    if(observer)
        return;

    observer = true;

    for(const element of document.querySelectorAll('time'))
        trackTimeElement(element);

    observer = new MutationObserver((records, observer) => {
        for(const record of records) {
            for(const node of record.removedNodes) {
                if(node instanceof HTMLTimeElement)
                    untrackTimeElement(time);
                if(node instanceof Element)
                    for(const time of node.querySelectorAll('time'))
                        untrackTimeElement(time);
            }

            for(const node of record.addedNodes) {
                if(node instanceof HTMLTimeElement)
                    trackTimeElement(time);
                if(node instanceof Element)
                    for(const time of node.querySelectorAll('time'))
                        trackTimeElement(time);
            }
        }
    });
    observer.observe(document.body, {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true,
    });
}

export function untrackTimeElements() {
    if(observer instanceof MutationObserver)
        observer.disconnect();
    if(!observer)
        return;
    observer = null;

    for(const element of Array.from(tracked.keys()))
        untrackTimeElement(element);
}
